// TODO: Ta bort detta efter att gigya är klart (används av fetchr)!
export const COOKIE_JWT = 'customer.mytui.web.jwt'
export const COOKIE_FULL_NAME = 'customer.mytui.web.full_name'
export const COOKIE_TUI_USER_ID = 'customer.mytui.web.user_id'
export const COOKIE_AVATAR = 'customer.mytui.web.avatar'
export const COOKIE_INITIALS = 'customer.mytui.web.initials'
export const COOKIE_FAVOURITES = 'customer.mytui.web.favourites'
export const COOKIE_FAVOURITES_IDS = 'customer.mytui.web.favourites.ids'
export const COOKIE_PREFERENCES_DEPARTURE_AIRPORTS = 'customer.mytui.web.preferences.airports'
export const COOKIE_PREFERENCES_TRAVELPARTY = 'customer.mytui.web.preferences.travelparty'
export const COOKIE_RECENT_USERS = 'customer.mytui.web.recent_users'
export const DEEP_LINK_BOOKING_NUMBER = 'customer.mytui.web.bookingnumber'
export const DEEP_LINK_BOOKING_TARGET = 'customer.mytui.web.bookingtarget'
export const MYHOLIDAY_SESSION_JWT = 'customer.myholiday.web.jwt'
// TODO: Tillfällig kaka som används under övergång till GIGYA. Ta bort när övergången är klar
export const COOKIE_AUTHENTICATION = 'customer.mytui.web.authentication'
export const COOKIE_BYPASS = 'customer.mytui.web.bypass'
export const COOKIE_EXPERIMENTAL = 'customer.mytui.web.experimental'
